var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatio1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H46C50.1421 0.5 53.5 3.85786 53.5 8V46C53.5 50.1421 50.1421 53.5 46 53.5H8C3.85786 53.5 0.5 50.1421 0.5 46V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H46C50.1421 0.5 53.5 3.85786 53.5 8V46C53.5 50.1421 50.1421 53.5 46 53.5H8C3.85786 53.5 0.5 50.1421 0.5 46V8Z",
    stroke: "#E5E5E5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#666666",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatio1);
export default __webpack_public_path__ + "static/media/ratio1.07ddf40d3c1f381912bdf5455255887a.svg";
export { ForwardRef as ReactComponent };